import { render, staticRenderFns } from "./corporate.vue?vue&type=template&id=1dd7c178&scoped=true"
import script from "./corporate.vue?vue&type=script&lang=js"
export * from "./corporate.vue?vue&type=script&lang=js"
import style0 from "./corporate.vue?vue&type=style&index=0&id=1dd7c178&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd7c178",
  null
  
)

export default component.exports